// extracted by mini-css-extract-plugin
module.exports = {"breadCrumbs":"breadcrumbs_breadCrumbs__NRLko","icon":"breadcrumbs_icon___A52n"};